import styled from 'styled-components';
import { TableCell } from '@material-ui/core';

export const UICell = styled(TableCell)``;
